






















import Vue, { PropType } from 'vue';
import { OrgPeerGroup } from '@/models/orgStructure';
import * as Utils from '@/utils';

import LazyRenderingList from '@/components/LazyRenderingList.vue';
import PeerGroupCard from '@/components/PeerGroupCard.vue';
import PeerGroupListCreator from '@/components/PeerGroupListCreator.vue';

export default Vue.extend({
  components: {
    LazyRenderingList,
    PeerGroupCard,
    PeerGroupListCreator
  },

  props: {
    filter: String,
    peerGroups: Array as PropType<OrgPeerGroup[]>,
    createEnabled: Boolean
  },

  computed: {
    separated(): OrgPeerGroup[] {
      const active = this.peerGroups.filter(pg => pg.isActive);
      const archived = this.peerGroups.filter(pg => !pg.isActive);

      return [...active, ...archived];
    },
    filtered(): OrgPeerGroup[] {
      if (!this.filter) {
        return this.separated;
      }

      return [
        ...Utils.findTerm(this.filter, this.separated, pg => [
          pg.name,
          pg.section,
          pg.description
        ])
      ];
    },
    hasResults(): boolean {
      return this.filtered.length > 0;
    },
    showCreateForm(): boolean {
      return this.createEnabled && !this.hasResults && !!this.filter;
    }
  },

  methods: {
    onCreate(group: { name: string; section: string; description: string }) {
      this.$emit('create-group', group);
    }
  },

  watch: {
    filtered(current, prev) {
      if (current.length != prev.length) {
        this.$emit('filter', { count: current.length });
      }
    }
  }
});
